const ACTIONS = {
    PREDICTION: 'prediction',
    PROJECT_NAME_CHANGE: 'project_name_change',
    PROJECT_NUMBER_CHANGE: 'project_number_change',
    PROJECT_GET_ALL: 'project_get_all'
};

export default ACTIONS;